/** @module csi/widget/_ScopeScrollMixin */
define([
	"dojo/_base/declare"
], function(declare) {
	
	/**
	 * This module creates intersection observer and call specified callback when DomNode becomes partially visible or invisible by scrolling
	 */

	return declare(null, {
		/** @private {Object} _intersectionObserver - used to track scrolls and closing drop down when control goes outside of visible area */  
		_intersectionObserver: null,
		
		/**
		 * @override
		 * Add intersection observer 
		 * @param {DomNode} domNode
		 * @param {Function} callback
		 */
		addIntersectionObserver: function(domNode, callback){
			// Trigger callback on scroll
			// This function only used for the case when cell is taller then then scroll node
			function onScroll(e){
				// Check if scrolling occur on the view rather then on inline editor 
				var el = domNode;
				while (el && (el != e.target)) {
					el = el.parentNode;
				}
				// If scroll happens in inline editor, it will be inside inline popup and outside of domNode branch (each popup dialog 
				// being added at the bottom of the html body) and therefore el will be null 
				// If scroll happens on view, then trigger callback
				if (el){
					callback();
					document.body.removeEventListener("scroll", onScroll, true);
				}
			}
	
			// Add obserer
			if (!this._intersectionObserver){
				var firstTime = true;
				this._intersectionObserver = new IntersectionObserver(entries => {
					// avoid triggering on first callback as it is always happen upon observer creation
					if (firstTime){
						firstTime = false;
						// Handle the case when element is only partially visible - editing large table cells which is taller then scroll node height
						// In this case intersectionObserver will not trigger properly, so add on scroll and react on any scroll
						if (entries[0].intersectionRatio < 1){
							document.body.addEventListener("scroll", onScroll, true);
						}
					} else if (entries[0].intersectionRatio < 1){ // If intersectionRatio < 1 means that control is not fully visible 
						callback();
					}
				}, {threshold: 1}); // If threshold == 0 observer will only trigger when control is fully invisible. 1 will trigger with any overlapping
				
				// start observing
				this._intersectionObserver.observe(domNode);
			}
		},
		
		/**
		 * @override
		 * Remove intersectionObserver
		 */
		removeIntersectionObserver: function(){
			var intersectionObserver = this._intersectionObserver;
			if (intersectionObserver){
				intersectionObserver.disconnect();
				delete this._intersectionObserver;
			} 
		}
		
	});
});